import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OCRService } from '@app/@core/services/ocr.service';
import { PrimengModule } from '@app/shared/modules/primeng.module';
import { FormioModule } from '@formio/angular';
import { CardiOcrModule } from '@pics-module/ocr';
import { OcrValidationRoutingModule } from './ocr-validation-routing.module';
import { OcrValidationComponent } from './ocr-validation.component';

@NgModule({
  declarations: [OcrValidationComponent],
  imports: [PrimengModule, CommonModule, FormioModule,
     OcrValidationRoutingModule, ReactiveFormsModule, FormsModule,CardiOcrModule],
  providers: [DatePipe, OCRService],
  exports: [OcrValidationComponent]
})
export class OcrValidationModule {}
